import { openMeetingBrief } from "@/features/clients/lib/meeting-brief-store";
import { cardChoice } from "@/features/intelligence/lib/card-choice";
import type { HandlerOutcome } from "@/features/intelligence/lib/frontend-tool-run";
import type { PrepareMeetingBriefArgs } from "@/features/intelligence/lib/frontend-tools";
import {
  choiceResult,
  searchedInstead,
  shownResult,
} from "@/features/intelligence/lib/tool-result";

export async function prepareMeetingBrief(
  { seed, meeting, ignored, notAnId }: PrepareMeetingBriefArgs,
  toolCallId: string,
): Promise<HandlerOutcome> {
  openMeetingBrief(toolCallId, seed, meeting ?? null);
  const header =
    meeting === undefined ? "" : "Its header names the meeting's time and place you passed. ";
  const choice = await cardChoice(seed, false);
  if (choice.kind !== "chosen") {
    return choiceResult(
      choice,
      searchedInstead(
        `A meeting brief card is in the chat. Once the client is chosen, it ${READS}. ${header}` +
          ASKS_PDF,
        seed,
        notAnId,
      ),
      KEEP_OUT,
      ignored,
    );
  }
  return shownResult(
    searchedInstead(
      `A meeting brief card is shown in the chat. You cannot see what it shows: it ${READS}. ` +
        `${header}${ASKS_PDF}`,
      seed,
      notAnId,
    ),
    `points to the card and says nothing about what is in it; ${KEEP_OUT}, and do not ask for ` +
      "anything in text",
    ignored,
  );
}

const READS = "reads the client's records itself, and none of them reach you";

const ASKS_PDF = "It then asks the advisor whether they want a one-page PDF";

const KEEP_OUT =
  "do not describe its contents in any way, not even in general terms such as that it holds " +
  "all the relevant information, do not summarise, list or guess them, do not offer a PDF " +
  "yourself";
